import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export interface DeductiblePreviewPayload {
  health_policy_id: number;
  family_deductible_amount: number;
  individual_deductibles?: Array<{
    employee_id?: number;
    dependent_id?: number;
    deductibles_amount: number;
  }>;
}
export type DeductiblePreviewResponse = {
  family_tier: string;
  is_tier_changed: boolean;
  accumulated_amount: number;
  individual_deductibles: Array<{
    employee_id: number;
    dependent_id: number | null;
    accumulated_amount: number;
    tier: string;
    is_tier_changed: boolean;
  }>;
};

export const useDeductiblePreviewQuery = (id?: string) => {
  const { mutateAsync, isLoading } = useMutation((payload: DeductiblePreviewPayload) =>
    api.post(API_URL.DEDUCTIBLES_EMPLOYEES_PREVIEW_BY_EMPLOYEE_ID(id || ''), payload)
  );

  const handleSave = async (payload: DeductiblePreviewPayload): Promise<DeductiblePreviewResponse> => {
    const response = await mutateAsync(payload);
    return response?.data as DeductiblePreviewResponse;
  };

  return {
    onSubmit: handleSave,
    isLoading,
  };
};
